import React from 'react';

const STAR_COUNT = 5;

function Stars({
  rating,
  count,
}: {
  rating: number;
  count: number;
}): React.JSX.Element {
  return (
    <div className="product-stars" aria-label={`${rating} out of 5`}>
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          {Array.from({ length: STAR_COUNT }, (_, i): React.JSX.Element => {
            const fillPercent = Math.min(100, Math.max(0, (rating - i) * 100));
            return (
              <linearGradient
                key={i}
                id={`star-fill-${i}-${rating}`}
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
              >
                <stop offset={`${fillPercent}%`} stopColor="currentColor" />
                <stop offset={`${fillPercent}%`} stopColor="transparent" />
              </linearGradient>
            );
          })}
        </defs>
      </svg>
      {Array.from({ length: STAR_COUNT }, (_, i): React.JSX.Element => (
        <svg
          key={i}
          className="product-stars--star"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
          width="18"
          height="18"
        >
          <path
            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
            fill={`url(#star-fill-${i}-${rating})`}
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        </svg>
      ))}
      <span className="product-stars--count">({count})</span>
    </div>
  );
}

export default Stars;
